export default "__VITE_ASSET__BMnBYciH__"